export enum AppState {
  LANDING = 'LANDING',
  EDITOR = 'EDITOR',
  PROCESSING = 'PROCESSING',
  READY = 'READY',
}

export type WatermarkPosition =
  | 'bottom-right'
  | 'bottom-left'
  | 'top-right'
  | 'top-left'
  | 'center';

export interface WatermarkOptions {
  enabled: boolean;
  logoFile: File | null;
  logoPreviewUrl: string | null;
  position: WatermarkPosition;
  /** Logo width as fraction of image width (0.05–0.5) */
  scale: number;
  /** 0–1 */
  opacity: number;
  /** Pixels from edge */
  margin: number;
}

export interface RenameOptions {
  enabled: boolean;
  pattern: string;
}

export type ResizeMode = 'standard' | 'tour360';

export interface ResizeOptions {
  /** Processing mode: standard photos vs 360 panoramas (forced 2:1) */
  mode: ResizeMode;
  /** null = keep original size */
  targetWidth: number | null;
  /**
   * JPEG quality (0.4–1.0). Used for output compression.
   * Defaults applied when null. Especially impactful for 360 panoramas
   * where the goal is to reduce MB without changing aspect ratio.
   */
  quality: number | null;
}

export interface ProcessingOptions {
  resize: ResizeOptions;
  watermark: WatermarkOptions;
  rename: RenameOptions;
}

export interface UploadedImage {
  id: string;
  file: File;
  previewUrl: string;
  originalWidth: number;
  originalHeight: number;
}

export interface ProcessingProgress {
  current: number;
  total: number;
  currentFileName: string;
}

export interface Feature {
  title: string;
  description: string;
  icon: string;
}
